import LoginPage from './container/index';

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/LoginForm/index.js